const included = [
  {
    icon: 'ri-check-double-line',
    title: 'Уникальность > 90%',
    text: 'Полностью авторский контент.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Польза (LSI-копирайтинг)',
    text: 'Ответ на реальный вопрос пользователя.',
  },
  {
    icon: 'ri-text-wrap',
    title: 'Форматирование для людей',
    text: 'Короткие абзацы, подзаголовки каждые 1000 знаков, списки.',
  },
  {
    icon: 'ri-user-badge-line',
    title: 'Блок автора',
    text: 'Фото и регалии эксперта — защита от теневого бана и рост доверия.',
  },
];

const plans = [
  {
    name: 'Старт',
    articles: '1–2 статьи в месяц',
    price: '3 000',
    desc: '«Поддерживающий» режим. Позволяет поисковикам видеть, что сайт живой. Подходит для микробизнеса.',
    features: ['1–2 SEO-статьи в месяц', 'Анализ ключевых запросов', 'Техническая SEO-упаковка', 'Внутренняя перелинковка'],
    accent: false,
    badge: null,
  },
  {
    name: 'Рост',
    articles: '4 статьи в месяц',
    price: '7 000',
    desc: 'Лучший темп для малого и среднего бизнеса. За год охватите 48 важных тем и создадите серьёзную базу трафика.',
    features: ['4 SEO-статьи в месяц', 'Стратегия контента', 'Технический SEO-аудит', 'Перелинковка + Мета-теги', 'Ежемесячный отчёт'],
    accent: true,
    badge: 'Оптимально',
  },
  {
    name: 'Агрессивный рост',
    articles: '8+ статей в месяц',
    price: '15 000',
    desc: 'Нужно, если вы выходите на высококонкурентный рынок и вы хотите быстро догнать лидеров.',
    features: ['8+ SEO-статей в месяц', 'Полная контент-стратегия', 'Конкурентный анализ', 'Приоритетная поддержка', 'Ежемесячный отчёт'],
    accent: false,
    badge: 'Агрессивный захват рынка',
  },
];

export default function SEOArticleResult() {
  return (
    <>
      {/* Result block */}
      <section id="seo-result" className="py-12 sm:py-24 bg-[#F9F5EF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-14">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
              <i className="ri-file-list-3-line text-[#C5A880] text-sm"></i>
              <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
                Состав каждой статьи
              </span>
            </div>
            <h2 className="text-2xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
              Что входит в каждую статью?
            </h2>
            <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
            {included.map((item, i) => (
              <div key={i} className="bg-white rounded-2xl p-4 sm:p-7 border border-gray-100 text-center hover:border-[#C5A880]/40 transition-all duration-300">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#1A2B4C] rounded-xl flex items-center justify-center mx-auto mb-3">
                  <i className={`${item.icon} text-base sm:text-xl text-white`}></i>
                </div>
                <h3 className="text-xs sm:text-base font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display'] leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-gray-600 leading-relaxed font-['Montserrat'] text-justify">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing block */}
      <section id="seo-pricing" className="py-12 sm:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-14">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#C5A880]/15 border border-[#C5A880]/30 mb-5">
              <i className="ri-price-tag-3-line text-[#C5A880] text-sm"></i>
              <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
                Тарифы
              </span>
            </div>
            <h2 className="text-2xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
              Сколько статей нужно вашему бизнесу?
            </h2>
            <div className="w-16 h-1 bg-[#C5A880] mx-auto mb-5 rounded-full"></div>
            <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
              Здесь нет жёсткого правила, но есть стратегия целесообразности:
            </p>
          </div>

          {/* Strategy descriptions */}
          <div className="grid sm:grid-cols-3 gap-3 sm:gap-4 mb-8 sm:mb-10">
            {[
              { icon: 'ri-seedling-line', label: 'Минимум', sub: '1–2 статьи в месяц', text: '«Поддерживающий» режим. Подходит для микробизнеса.' },
              { icon: 'ri-bar-chart-line', label: 'Оптимально', sub: '4 статьи в месяц', text: 'Лучший темп для малого и среднего бизнеса. За год охват 48 тем и серьёзная база трафика.' },
              { icon: 'ri-rocket-2-line', label: 'Агрессивно', sub: '8+ статей в месяц', text: 'Нужно, если выходите на конкурентный рынок и хотите быстро догнать лидеров.' },
            ].map((s, i) => (
              <div key={i} className="bg-[#F8F9FA] rounded-2xl p-4 sm:p-5 flex items-start gap-3 border border-gray-100">
                <div className="w-8 h-8 sm:w-9 sm:h-9 bg-[#C5A880] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${s.icon} text-sm sm:text-base text-white`}></i>
                </div>
                <div>
                  <div className="font-bold text-[#1A2B4C] text-xs sm:text-sm font-['Montserrat']">{s.label}: {s.sub}</div>
                  <div className="text-xs text-gray-500 font-['Montserrat'] mt-0.5 text-justify">{s.text}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Price cards */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
            {plans.map((plan, i) => (
              <div
                key={i}
                className={`relative rounded-2xl sm:rounded-3xl p-5 sm:p-8 border transition-all duration-300 flex flex-col ${plan.accent ? 'bg-[#1A2B4C] border-[#1A2B4C] text-white' : 'bg-white border-gray-200 hover:border-[#C5A880]/50'}`}
              >
                {plan.badge && (
                  <span className={`absolute -top-3 left-1/2 -translate-x-1/2 text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap font-['Montserrat'] ${plan.accent ? 'bg-[#C5A880] text-white' : 'bg-[#1A2B4C] text-white'}`}>
                    {plan.badge}
                  </span>
                )}

                <div className="mb-4">
                  <h3 className={`text-base sm:text-xl font-bold font-['Playfair_Display'] mb-1 ${plan.accent ? 'text-white' : 'text-[#1A2B4C]'}`}>
                    Пакет «{plan.name}»
                  </h3>
                  <p className={`text-xs font-['Montserrat'] ${plan.accent ? 'text-white/60' : 'text-gray-500'}`}>
                    {plan.articles}
                  </p>
                </div>

                <div className="mb-4">
                  <span className={`text-2xl sm:text-4xl font-bold font-['Playfair_Display'] ${plan.accent ? 'text-[#C5A880]' : 'text-[#1A2B4C]'}`}>
                    {plan.price}
                  </span>
                  <span className={`text-sm ml-1 font-['Montserrat'] ${plan.accent ? 'text-white/60' : 'text-gray-500'}`}>
                    руб./мес.
                  </span>
                </div>

                <p className={`text-xs sm:text-sm leading-relaxed font-['Montserrat'] mb-4 text-justify ${plan.accent ? 'text-white/70' : 'text-gray-600'}`}>
                  {plan.desc}
                </p>

                <ul className="space-y-2 mb-6 flex-1">
                  {plan.features.map((f, fi) => (
                    <li key={fi} className="flex items-center gap-2">
                      <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 ${plan.accent ? 'bg-[#C5A880]/30' : 'bg-[#C5A880]/15'}`}>
                        <i className="ri-check-line text-[#C5A880] text-xs"></i>
                      </div>
                      <span className={`text-xs font-['Montserrat'] ${plan.accent ? 'text-white/80' : 'text-gray-700'}`}>{f}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#seo-article-form"
                  className={`block text-center py-3 rounded-xl text-sm font-semibold font-['Montserrat'] transition-all duration-300 whitespace-nowrap cursor-pointer ${plan.accent ? 'bg-[#C5A880] hover:bg-[#B39770] text-white' : 'bg-[#1A2B4C] hover:bg-[#253D6B] text-white'}`}
                >
                  Выбрать «{plan.name}»
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
